<nav
  class="sticky top-0 z-50 bg-dark-900/90 backdrop-blur-lg border-b border-white/5 px-6 py-4 flex justify-between items-center transition-all duration-300">
  <div class="flex items-center gap-3 group cursor-pointer" routerLink="/">
    <img src="/loony-Token.png" alt="LoonyStake Logo"
      class="w-10 h-10 rounded-xl shadow-[0_0_15px_rgba(145,70,255,0.3)] group-hover:shadow-[0_0_25px_rgba(145,70,255,0.5)] transition-all duration-300 transform group-hover:scale-105 object-contain bg-white/5 p-1" />
    <span
      class="text-xl font-groozila bg-clip-text text-transparent bg-gradient-to-r from-primary-100 to-primary-500 tracking-wider">
      LoonyStake
    </span>
  </div>

  <div class="flex items-center gap-6">

    <!-- Reown AppKit Web Component for Wallet Connection -->
    <appkit-button></appkit-button>
  </div>
</nav>